import { combineReducers } from "redux";

export const modalReducer = (MODAL_NAME, SHOW_INIT = false) => (state = getEmptyState(SHOW_INIT), action) => {
  if (action.type === `${MODAL_NAME}_TOGGLE`) return { ...state, visible: action.payload };
  return state;
};

function getEmptyState(SHOW_INIT) {
  return {
    visible: SHOW_INIT,
  };
}
export const modalsReducer = combineReducers({
  CookiesModal: modalReducer("CookiesModal", true),
  PrivacyPolicyModal: modalReducer("PrivacyPolicyModal"),
  ConfigurePrivacyModal: modalReducer("ConfigurePrivacyModal"),
});
